import { initialData } from '../initailData';
import { SET_TOKEN_REQUEST_DATA, SET_TOKEN } from '../storeConstants';


const InitTokenReducer = (state = initialData.token, action) => {
    switch(action.type) {
        case SET_TOKEN:
            return {
                ...state,
                token: action.payload
            }

        case SET_TOKEN_REQUEST_DATA:
            return {
                ...state,
                tokenRequestData: action.payload    
            }

        default:
            return state;
    }
}

export default InitTokenReducer;